import { render, staticRenderFns } from "./DashboardTotalCard.vue?vue&type=template&id=87cdf7b0&"
import script from "./DashboardTotalCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardTotalCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports